import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://aadhavacademy.com/api/study/book.php';

// Thunks
export const fetchBooks = createAsyncThunk('books/fetchBooks', async (params) => {
  const { search, page, limit } = params;
  const response = await axios.get(API_URL, { params: { search, page, limit } });
  return response.data;
});

export const addBook = createAsyncThunk('books/addBook', async (bookData) => {
  const response = await axios.post(API_URL, bookData);
  return response.data;
});

export const updateBook = createAsyncThunk('books/updateBook', async ({ id, bookData }) => {
  const response = await axios.put(`${API_URL}?id=${id}`, bookData);
  return response.data;
});

export const deleteBook = createAsyncThunk('books/deleteBook', async (id) => {
  const response = await axios.delete(`${API_URL}?id=${id}`);
  return response.data;
});

const bookSlice = createSlice({
  name: 'books',
  initialState: {
    books: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    selectedBook: null,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedBook: (state, action) => {
      state.selectedBook = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBooks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBooks.fulfilled, (state, action) => {
        state.books = action.payload.books || [];
        state.total = action.payload.total || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.loading = false;
      })
      .addCase(fetchBooks.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(addBook.fulfilled, (state, action) => {
        state.books.push(action.payload);
      })
      .addCase(updateBook.fulfilled, (state, action) => {
        const updated = action.payload;
        state.books = state.books.map((book) =>
          book.book_id === updated.book_id ? updated : book
        );
      })
      .addCase(deleteBook.fulfilled, (state, action) => {
        state.books = state.books.filter((book) => book.book_id !== action.payload.book_id);
      });
  },
});

export const { setCurrentPage, setSelectedBook } = bookSlice.actions;
export default bookSlice.reducer;
